/* sm-learn-toc — positions the sticky TOC rail across the chapter sections; in-page smooth scrolling with sticky-header offset. */
(function () {
  'use strict';
  var FALLBACK_OFFSET = 100;

  function headerOffset() {
    var total = 0;
    var candidates = document.querySelectorAll('.shopify-section-group-header-group, #header-group, .sm-header, .sm-announcement-bar');
    var seen = [];
    candidates.forEach(function (el) {
      var cs = getComputedStyle(el);
      var r = el.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') && r.top <= 1 && r.height > 0 && r.height < 300) {
        if (seen.some(function (o) { return o.contains(el) || el.contains(o); })) return;
        seen.push(el); total += r.height;
      }
    });
    if (!total) {
      var hg = document.getElementById('header-group') || document.querySelector('.shopify-section-group-header-group');
      if (hg) { var rr = hg.getBoundingClientRect(); if (rr.top <= 1 && rr.height > 0 && rr.height < 300) total = rr.height; }
    }
    return total || FALLBACK_OFFSET;
  }

  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var top = e.target.closest('[data-sm-learn-top]');
    if (top) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var a = e.target.closest('[data-sm-learn-scroll]');
    if (!a) return;
    var id = a.getAttribute('data-sm-learn-scroll') || (a.getAttribute('href') || '').replace(/^#/, '');
    if (id && scrollToId(id)) e.preventDefault();
  });

  function initRail(root) {
    var rail = root.querySelector('.sm-learn-toc__rail');
    var sticky = root.querySelector('.sm-learn-toc__sticky');
    if (!rail) return;
    function place() {
      var chapters = document.querySelectorAll('.sm-learn-chapter');
      if (!chapters.length || window.innerWidth <= 1024) { rail.hidden = true; return; }
      var first = chapters[0].querySelector('.sm-learn-chapter__body') || chapters[0];
      var last = chapters[chapters.length - 1];
      var rootTop = root.getBoundingClientRect().top;
      var top = first.getBoundingClientRect().top - rootTop;
      var bottom = last.getBoundingClientRect().bottom - rootTop;
      if (bottom - top < 100) { rail.hidden = true; return; }
      rail.hidden = false;
      rail.style.top = Math.round(top) + 'px';
      rail.style.height = Math.round(bottom - top) + 'px';
      if (sticky) sticky.style.top = headerOffset() + 'px';
    }
    place();
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    if ('ResizeObserver' in window) {
      var main = document.getElementById('MainContent') || document.body;
      new ResizeObserver(function () { place(); }).observe(main);
    }
    document.addEventListener('shopify:section:load', place);
    document.addEventListener('shopify:section:reorder', place);
  }

  function boot() { document.querySelectorAll('[data-sm-learn-toc]').forEach(initRail); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
